import { FC } from "preact/compat";
import { leadZero } from "~/utils";
import WheelInput from "./WheelInput";
import { WheelTimeInputProps } from "./interfaces";

const getWheels = (min: Date | null | undefined) => {
    // hours & minutes
    const hours = [];
    const minutes = [];
    const minHour = min?.getHours() ?? 0;

    for (let i = minHour; i < 24; ++i) {
        hours.push({
            label: leadZero(i),
            value: i.toString(),
        });
    }

    for (let i = 0; i < 60; ++i) {
        minutes.push({
            label: leadZero(i),
            value: i.toString(),
        });
    }

    return [
        {
            label: "Hours",
            choices: hours,
        },
        {
            label: "Minutes",
            choices: minutes,
        },
    ];
};

const getValue = (value: Date) => {
    return [value.getHours().toString(), value.getMinutes().toString()];
};

const WheelTimeInput: FC<WheelTimeInputProps> = ({
    show,
    value,
    onChange,
    min,
    className,
}) => {
    const wheels = getWheels(min);
    const values = getValue(value);

    const handleChange = (newValues: string[]) => {
        const newDate = new Date(value);

        newDate.setHours(parseInt(newValues[0], 10));
        newDate.setMinutes(parseInt(newValues[1], 10));
        newDate.setSeconds(0);

        onChange(newDate);
    };

    return (
        <WheelInput
            show={show}
            wheels={wheels}
            value={values}
            onChange={handleChange}
            className={className}
            renderLabel={(values) =>
                values.map((v) => leadZero(Number(v))).join(":")
            }
        />
    );
};

export default WheelTimeInput;
